var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-sheet best-seller-sheet-layout",class:{'no-padding-top' : (_vm.bestSellerFinitions.length<2) }},[_c('layout-part-sheet-header',{attrs:{"product-datas":_vm.productDatas,"is-best-seller":true,"best-seller-finitions":_vm.bestSellerFinitions}}),_c('trigger-btn-standard'),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }